// The four pillars, same words as before, as a hairline list in two columns:
// a mono kind, the heading, the paragraph. No cards, no icons.
export const pillars = [
  {
    kind: "01 / playbooks",
    title: "Reproducible AI playbooks from real client work.",
    body: "Every workflow comes from a paid engagement. You get the prompt chain, the tool stack, the gotchas, and the result. Copy it, adapt it, ship it the same afternoon.",
  },
  {
    kind: "02 / hub",
    title: "A private hub of serious analysts.",
    body: "Threads with founders, fund managers and independent analysts. A global member map so you know who is in the room, not just a chat ID.",
  },
  {
    kind: "03 / founder",
    title: "Direct line to the founder.",
    body: "Post a question. Shubham reads everything. No queue, no community manager filtering you out.",
  },
  {
    kind: "04 / early access",
    title: "First look at new drops.",
    body: "Tools, masterclasses and research land here before anywhere else.",
  },
];

export function ClubPillarsGrid() {
  return (
    <div className="mt-12 grid gap-x-14 md:grid-cols-2">
      {pillars.map((p) => (
        <div key={p.kind} className="border-t border-[var(--sn-border)] py-6">
          <p className="sn-label">{p.kind}</p>
          <h3 className="mt-3 max-w-[26ch] text-[22px] font-semibold leading-[1.2] tracking-[-0.02em] text-foreground">{p.title}</h3>
          <p className="mt-3 max-w-[52ch] text-[15px] leading-[1.55] text-[var(--sn-fg2)]">{p.body}</p>
        </div>
      ))}
    </div>
  );
}
